!(function (e) {
  "use strict";
  var t = function (e, n) {
    return (
      (t =
        Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array &&
          function (e, t) {
            e.__proto__ = t;
          }) ||
        function (e, t) {
          for (var n in t)
            Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }),
      t(e, n)
    );
  };
  var n = function () {
    return (
      (n =
        Object.assign ||
        function (e) {
          for (var t, n = 1, o = arguments.length; n < o; n++)
            for (var r in (t = arguments[n]))
              Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          return e;
        }),
      n.apply(this, arguments)
    );
  };
  function o(e, t, n, o) {
    return new (n || (n = Promise))(function (r, i) {
      function a(e) {
        try {
          l(o.next(e));
        } catch (e) {
          i(e);
        }
      }
      function c(e) {
        try {
          l(o.throw(e));
        } catch (e) {
          i(e);
        }
      }
      function l(e) {
        var t;
        e.done
          ? r(e.value)
          : ((t = e.value),
            t instanceof n
              ? t
              : new n(function (e) {
                  e(t);
                })).then(a, c);
      }
      l((o = o.apply(e, t || [])).next());
    });
  }
  function r(e, t) {
    var n,
      o,
      r,
      i,
      a = {
        label: 0,
        sent: function () {
          if (1 & r[0]) throw r[1];
          return r[1];
        },
        trys: [],
        ops: [],
      };
    return (
      (i = { next: c(0), throw: c(1), return: c(2) }),
      "function" == typeof Symbol &&
        (i[Symbol.iterator] = function () {
          return this;
        }),
      i
    );
    function c(i) {
      return function (c) {
        return (function (i) {
          if (n) throw new TypeError("Generator is already executing.");
          for (; a; )
            try {
              if (
                ((n = 1),
                o &&
                  (r =
                    2 & i[0]
                      ? o.return
                      : i[0]
                      ? o.throw || ((r = o.return) && r.call(o), 0)
                      : o.next) &&
                  !(r = r.call(o, i[1])).done)
              )
                return r;
              switch (((o = 0), r && (i = [2 & i[0], r.value]), i[0])) {
                case 0:
                case 1:
                  r = i;
                  break;
                case 4:
                  return a.label++, { value: i[1], done: !1 };
                case 5:
                  a.label++, (o = i[1]), (i = [0]);
                  continue;
                case 7:
                  (i = a.ops.pop()), a.trys.pop();
                  continue;
                default:
                  if (
                    !((r = a.trys),
                    (r = r.length > 0 && r[r.length - 1]) ||
                      (6 !== i[0] && 2 !== i[0]))
                  ) {
                    a = 0;
                    continue;
                  }
                  if (3 === i[0] && (!r || (i[1] > r[0] && i[1] < r[3]))) {
                    a.label = i[1];
                    break;
                  }
                  if (6 === i[0] && a.label < r[1]) {
                    (a.label = r[1]), (r = i);
                    break;
                  }
                  if (r && a.label < r[2]) {
                    (a.label = r[2]), a.ops.push(i);
                    break;
                  }
                  r[2] && a.ops.pop(), a.trys.pop();
                  continue;
              }
              i = t.call(e, a);
            } catch (e) {
              (i = [6, e]), (o = 0);
            } finally {
              n = r = 0;
            }
          if (5 & i[0]) throw i[1];
          return { value: i[0] ? i[1] : void 0, done: !0 };
        })([i, c]);
      };
    }
  }
  var i = Object.create
    ? function (e, t, n, o) {
        void 0 === o && (o = n);
        var r = Object.getOwnPropertyDescriptor(t, n);
        (r && !("get" in r ? !t.__esModule : r.writable || r.configurable)) ||
          (r = {
            enumerable: !0,
            get: function () {
              return t[n];
            },
          }),
          Object.defineProperty(e, o, r);
      }
    : function (e, t, n, o) {
        void 0 === o && (o = n), (e[o] = t[n]);
      };
  function a(e) {
    var t = "function" == typeof Symbol && Symbol.iterator,
      n = t && e[t],
      o = 0;
    if (n) return n.call(e);
    if (e && "number" == typeof e.length)
      return {
        next: function () {
          return (
            e && o >= e.length && (e = void 0), { value: e && e[o++], done: !e }
          );
        },
      };
    throw new TypeError(
      t ? "Object is not iterable." : "Symbol.iterator is not defined."
    );
  }
  function c(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var o,
      r,
      i = n.call(e),
      a = [];
    try {
      for (; (void 0 === t || t-- > 0) && !(o = i.next()).done; )
        a.push(o.value);
    } catch (e) {
      r = { error: e };
    } finally {
      try {
        o && !o.done && (n = i.return) && n.call(i);
      } finally {
        if (r) throw r.error;
      }
    }
    return a;
  }
  function l(e) {
    return this instanceof l ? ((this.v = e), this) : new l(e);
  }
  var s = Object.create
    ? function (e, t) {
        Object.defineProperty(e, "default", { enumerable: !0, value: t });
      }
    : function (e, t) {
        e.default = t;
      };
  var d,
    u,
    p,
    h,
    f,
    m,
    g,
    y,
    v,
    b = Object.freeze({
      __proto__: null,
      __extends: function (e, n) {
        if ("function" != typeof n && null !== n)
          throw new TypeError(
            "Class extends value " + String(n) + " is not a constructor or null"
          );
        function o() {
          this.constructor = e;
        }
        t(e, n),
          (e.prototype =
            null === n
              ? Object.create(n)
              : ((o.prototype = n.prototype), new o()));
      },
      get __assign() {
        return n;
      },
      __rest: function (e, t) {
        var n = {};
        for (var o in e)
          Object.prototype.hasOwnProperty.call(e, o) &&
            t.indexOf(o) < 0 &&
            (n[o] = e[o]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var r = 0;
          for (o = Object.getOwnPropertySymbols(e); r < o.length; r++)
            t.indexOf(o[r]) < 0 &&
              Object.prototype.propertyIsEnumerable.call(e, o[r]) &&
              (n[o[r]] = e[o[r]]);
        }
        return n;
      },
      __decorate: function (e, t, n, o) {
        var r,
          i = arguments.length,
          a =
            i < 3
              ? t
              : null === o
              ? (o = Object.getOwnPropertyDescriptor(t, n))
              : o;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate)
          a = Reflect.decorate(e, t, n, o);
        else
          for (var c = e.length - 1; c >= 0; c--)
            (r = e[c]) &&
              (a = (i < 3 ? r(a) : i > 3 ? r(t, n, a) : r(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      },
      __param: function (e, t) {
        return function (n, o) {
          t(n, o, e);
        };
      },
      __metadata: function (e, t) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata)
          return Reflect.metadata(e, t);
      },
      __awaiter: o,
      __generator: r,
      __createBinding: i,
      __exportStar: function (e, t) {
        for (var n in e)
          "default" === n ||
            Object.prototype.hasOwnProperty.call(t, n) ||
            i(t, e, n);
      },
      __values: a,
      __read: c,
      __spread: function () {
        for (var e = [], t = 0; t < arguments.length; t++)
          e = e.concat(c(arguments[t]));
        return e;
      },
      __spreadArrays: function () {
        for (var e = 0, t = 0, n = arguments.length; t < n; t++)
          e += arguments[t].length;
        var o = Array(e),
          r = 0;
        for (t = 0; t < n; t++)
          for (var i = arguments[t], a = 0, c = i.length; a < c; a++, r++)
            o[r] = i[a];
        return o;
      },
      __spreadArray: function (e, t, n) {
        if (n || 2 === arguments.length)
          for (var o, r = 0, i = t.length; r < i; r++)
            (!o && r in t) ||
              (o || (o = Array.prototype.slice.call(t, 0, r)), (o[r] = t[r]));
        return e.concat(o || Array.prototype.slice.call(t));
      },
      __await: l,
      __asyncGenerator: function (e, t, n) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var o,
          r = n.apply(e, t || []),
          i = [];
        return (
          (o = {}),
          a("next"),
          a("throw"),
          a("return"),
          (o[Symbol.asyncIterator] = function () {
            return this;
          }),
          o
        );
        function a(e) {
          r[e] &&
            (o[e] = function (t) {
              return new Promise(function (n, o) {
                i.push([e, t, n, o]) > 1 || c(e, t);
              });
            });
        }
        function c(e, t) {
          try {
            (n = r[e](t)).value instanceof l
              ? Promise.resolve(n.value.v).then(s, d)
              : u(i[0][2], n);
          } catch (e) {
            u(i[0][3], e);
          }
          var n;
        }
        function s(e) {
          c("next", e);
        }
        function d(e) {
          c("throw", e);
        }
        function u(e, t) {
          e(t), i.shift(), i.length && c(i[0][0], i[0][1]);
        }
      },
      __asyncDelegator: function (e) {
        var t, n;
        return (
          (t = {}),
          o("next"),
          o("throw", function (e) {
            throw e;
          }),
          o("return"),
          (t[Symbol.iterator] = function () {
            return this;
          }),
          t
        );
        function o(o, r) {
          t[o] = e[o]
            ? function (t) {
                return (n = !n)
                  ? { value: l(e[o](t)), done: "return" === o }
                  : r
                  ? r(t)
                  : t;
              }
            : r;
        }
      },
      __asyncValues: function (e) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var t,
          n = e[Symbol.asyncIterator];
        return n
          ? n.call(e)
          : ((e = a(e)),
            (t = {}),
            o("next"),
            o("throw"),
            o("return"),
            (t[Symbol.asyncIterator] = function () {
              return this;
            }),
            t);
        function o(n) {
          t[n] =
            e[n] &&
            function (t) {
              return new Promise(function (o, r) {
                (function (e, t, n, o) {
                  Promise.resolve(o).then(function (t) {
                    e({ value: t, done: n });
                  }, t);
                })(o, r, (t = e[n](t)).done, t.value);
              });
            };
        }
      },
      __makeTemplateObject: function (e, t) {
        return (
          Object.defineProperty
            ? Object.defineProperty(e, "raw", { value: t })
            : (e.raw = t),
          e
        );
      },
      __importStar: function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e)
          for (var n in e)
            "default" !== n &&
              Object.prototype.hasOwnProperty.call(e, n) &&
              i(t, e, n);
        return s(t, e), t;
      },
      __importDefault: function (e) {
        return e && e.__esModule ? e : { default: e };
      },
      __classPrivateFieldGet: function (e, t, n, o) {
        if ("a" === n && !o)
          throw new TypeError("Private accessor was defined without a getter");
        if ("function" == typeof t ? e !== t || !o : !t.has(e))
          throw new TypeError(
            "Cannot read private member from an object whose class did not declare it"
          );
        return "m" === n ? o : "a" === n ? o.call(e) : o ? o.value : t.get(e);
      },
      __classPrivateFieldSet: function (e, t, n, o, r) {
        if ("m" === o) throw new TypeError("Private method is not writable");
        if ("a" === o && !r)
          throw new TypeError("Private accessor was defined without a setter");
        if ("function" == typeof t ? e !== t || !r : !t.has(e))
          throw new TypeError(
            "Cannot write private member to an object whose class did not declare it"
          );
        return "a" === o ? r.call(e, n) : r ? (r.value = n) : t.set(e, n), n;
      },
      __classPrivateFieldIn: function (e, t) {
        if (null === t || ("object" != typeof t && "function" != typeof t))
          throw new TypeError("Cannot use 'in' operator on non-object");
        return "function" == typeof e ? t === e : e.has(t);
      },
    });
  function w(e, t) {
    if (void 0 !== e) {
      var n = e.filter(t);
      return n.length ? n[0] : void 0;
    }
  }
  function C(e) {
    var t = window.location.search.substring(1);
    if (0 === t.length) return null;
    var n = t.split("&").map(function (e) {
        return e.split("=");
      }),
      o = n.filter(function (t) {
        return t[0] === e;
      })[0];
    return (o ? o[1] : null) || null;
  }
  function P(e) {
    for (
      var t = 0, n = decodeURIComponent(document.cookie).split(";");
      t < n.length;
      t++
    ) {
      var o = n[t].split("="),
        r = o[0],
        i = o[1];
      if (r.trim() === e) return i;
    }
    return "";
  }
  function B(e, t) {
    var n = Boolean(e);
    return t
      ? "display: none;"
      : n
      ? "\n      z-index: 9000;\n      position: fixed;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      background-color: rgba(0, 0, 0, 0.6);\n    "
      : "display: none;";
  }
  function x(e) {
    var t = (function (e) {
        if (e === v.Dark)
          return {
            banner: d.Black,
            bannerFont: d.White,
            buttonBorderColor: d.White,
            toggleSectionDivider: d.VeryDarkGray,
          };
        return {
          banner: d.White,
          bannerFont: d.Black,
          buttonBorderColor: d.Black,
          toggleSectionDivider: d.VeryLightGray,
        };
      })(e.theme),
      n = B(y.Yes, !1),
      o = e.theme === v.Dark ? d.White : d.Black,
      r = (function (e) {
        return e === v.Dark ? d.Black : d.White;
      })(e.theme),
      i = (function (e) {
        return e === v.Dark ? d.Gray : "rgba(0, 0, 0, 0.25)";
      })(e.theme),
      a = (function (e) {
        return e === v.Dark ? d.DarkGray : d.LightGray;
      })(e.theme),
      c = _(h.EssentialToggleId, h.EssentialToggleClass),
      l = _(h.MarketingToggleId, h.MarketingToggleClass),
      s = _(h.StatisticsToggleId, h.StatisticsToggleClass),
      u = _(h.PreferencesToggleId, h.PreferencesToggleClass),
      p = _(h.AttributionToggleId, h.AttributionToggleClass);
    return "\n    #"
      .concat(h.ModalWrapperId, " {\n      position: relative;\n    }\n    #")
      .concat(
        h.ModalWrapperId,
        ':after {\n      content: "";\n      display: block;\n      clear: both;\n    }\n    #'
      )
      .concat(
        h.ModalId,
        " {\n      box-shadow: 0px 4px 10px rgb(63 63 68 / 40%);\n      position: fixed;\n      z-index: 9999;\n      opacity: 1;\n      background-color: "
      )
      .concat(
        t.banner,
        ";\n      top: 50%;\n      left: 50%;\n      max-height: 80%;\n      overflow-y: auto;\n      transform: translate(-50%, -50%);\n      max-width: 600px;\n      min-width: 320px;\n      border-radius: 3px;\n      display: flex;\n      flex-direction: column;\n    }\n    #"
      )
      .concat(h.OverlayId, " {\n      ")
      .concat(n, "\n    }\n    #")
      .concat(
        h.BodyDivId,
        " {\n      float: 'left';\n      overflow-y: auto;\n      padding: 30px 40px 0px 40px;\n    }\n    #"
      )
      .concat(h.DivId, " h1 {\n      color: ")
      .concat(
        t.bannerFont,
        ";\n      font-family: inherit;\n      margin: 0 0 .5em 0;\n      padding: 0;\n      font-weight: bold;\n      font-size: 200%;\n      line-height: 1.1;\n    }\n    #"
      )
      .concat(h.DivId, " p {\n      color: ")
      .concat(
        t.bannerFont,
        ";\n      font-family: inherit;\n      line-height: 1.3;\n      margin: 0;\n      padding: 0;\n      font-size: 100%;\n    }\n    #"
      )
      .concat(
        h.DivId,
        " a {\n      color: #fff;\n      text-decoration: underline;\n    }\n    ."
      )
      .concat(
        h.ActionButtonClass,
        " {\n      margin: 15px 0 0 0;\n      display: flex;\n      justify-content: space-around;\n      flex-direction: row;\n      padding: 0px 40px 30px 40px;\n    }\n    @media only screen and (max-width: 1000px) {\n      ."
      )
      .concat(
        h.ActionButtonClass,
        " {\n        flex-direction: column;\n      }\n    }\n    #"
      )
      .concat(
        h.DivId,
        " button {\n      border: none;\n      text-decoration: none;\n      font-family: inherit;\n      border-radius: 4px;\n      padding: 5px 10px;\n      margin: 15px 10px 0 0;\n      font-size: 120%;\n      width: 33%;\n      background-color: "
      )
      .concat(o, ";\n      color: ")
      .concat(
        r,
        ";\n    }\n    @media only screen and (max-width: 1000px) {\n      #"
      )
      .concat(h.DivId, " button {\n        width: 100%;\n      }\n    }\n    #")
      .concat(h.DivId, " button:hover {\n      cursor: pointer;\n    }\n    .")
      .concat(
        h.ActionButtonClass,
        " button {\n      opacity: 1;\n      transition: opacity 0.1s;\n    }\n    ."
      )
      .concat(
        h.ActionButtonClass,
        " button:hover {\n      opacity: 0.85;\n    }\n    #"
      )
      .concat(h.ToggleDivWrapper, " {\n      color: ")
      .concat(t.bannerFont, ";\n      border-top: 1px solid ")
      .concat(
        t.toggleSectionDivider,
        ";\n      margin: 20px 0 0 0;\n    }\n    ."
      )
      .concat(
        h.ToggleDiv,
        " {\n      margin: 0;\n      font-size: 100%;\n      line-height: 1.1;\n      padding: 10px 13px 10px 13px;\n      border-bottom: 1px solid "
      )
      .concat(t.toggleSectionDivider, ";\n    }\n    .")
      .concat(
        h.ToggleDefaultContent,
        " {\n      display: flex;\n      align-items: flex-start;\n      justify-content: space-between;\n      position: relative;\n    }\n    ."
      )
      .concat(h.ToggleDiv, " .")
      .concat(
        h.ToggleExpandedContent,
        " {\n      border-radius: 5px;\n      overflow: hidden;\n      padding: 0 1em;\n      transition: all .1s ease-out;\n      height: 0px;\n    }\n    ."
      )
      .concat(h.ToggleDiv, ".active .")
      .concat(
        h.ToggleDefaultContent,
        " {\n      font-weight: bold;\n    }\n    ."
      )
      .concat(h.ToggleDiv, ".active .")
      .concat(
        h.ToggleExpandedContent,
        " {\n      margin-top: 5px;\n      height: auto;\n    }\n    ."
      )
      .concat(
        h.ToggleDiv,
        ":hover {\n      cursor: pointer;\n      background-color: "
      )
      .concat(
        a,
        ";\n    }\n    .desc {\n      margin-right: 10px;\n    }\n    .switch {\n      position: relative;\n      display: inline-block;\n      min-width: 40px;\n      width: 40px;\n      height: 20px;\n      background-color: "
      )
      .concat(
        i,
        ";\n      border-radius: 20px;\n      transition: all 0.1s;\n      cursor: pointer;\n    }\n    .switch::after {\n      content: '';\n      position: absolute;\n      width: 18px;\n      height: 18px;\n      border-radius:50%;\n      background-color: white;\n      top: 1px;\n      left: 1px;\n      transition: all 0.1s;\n    }\n    ::-webkit-scrollbar {\n      width: 0px;\n      background: transparent; /* make scrollbar transparent */\n    }\n    "
      )
      .concat(c, "\n    ")
      .concat(l, "\n    ")
      .concat(s, "\n    ")
      .concat(u, "\n    ")
      .concat(p, "\n    ​");
  }
  function _(e, t) {
    var n = e === h.EssentialToggleId ? "0.5" : "1";
    return "\n    ."
      .concat(
        t,
        ":checked + .switch::after {\n      left : 20px;\n    }\n    ."
      )
      .concat(t, ":checked + .switch {\n      background-color: ")
      .concat(d.Green, ";\n      opacity: ")
      .concat(n, "\n    }\n    #")
      .concat(e, " {\n      display: none;\n    }\n  ");
  }
  function E(e, t, n) {
    void 0 === t && (t = !1);
    var o = (function (e) {
        if (e === v.Dark)
          return {
            banner: d.Black,
            bannerFont: d.White,
            buttonBorderColor: d.White,
            toggleSectionDivider: d.VeryDarkGray,
          };
        return {
          banner: d.White,
          bannerFont: d.Black,
          buttonBorderColor: d.Black,
          toggleSectionDivider: d.VeryLightGray,
        };
      })(e.theme),
      r = B(null == n ? void 0 : n.overlay, t),
      i = (function (e, t) {
        var n = "\n    bottom: 0%;\n    width: 100%;\n  ";
        if (t) return n;
        switch (e) {
          case f.BottomFullWidth:
            return n;
          case f.Center:
            return "\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    max-width: 520px;\n    min-width: 320px;\n    border-radius: 3px;\n  ";
          case f.BottomLeft:
            return "\n    bottom: 0;\n    left: 0;\n    max-width: 520px;\n    border-top-right-radius: 3px;\n  ";
          case f.BottomRight:
            return "\n    bottom: 0;\n    right: 0;\n    max-width: 520px;\n    border-top-left-radius: 3px;\n  ";
          case f.BottomCenter:
            return "\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    max-width: 520px;\n    min-width: 320px;\n    border-top-right-radius: 3px;\n    border-top-left-radius: 3px;\n  ";
          default:
            return n;
        }
      })(null == n ? void 0 : n.bannerPlacement, t),
      a = (function (e) {
        switch (e) {
          case m.AcceptFirst:
            return "flex-direction: row;";
          case m.DeclineFirst:
            return "flex-direction: row-reverse;";
          default:
            return "flex-direction: row;";
        }
      })(null == n ? void 0 : n.buttonPlacement),
      c = (function (e, t) {
        var n = t === v.Dark,
          o = "\n    background: "
            .concat(n ? d.White : d.Black, ";\n    color: ")
            .concat(n ? d.Black : d.White, ";\n  "),
          r = "\n    background: "
            .concat(n ? d.Black : d.White, ";\n    color: ")
            .concat(n ? d.White : d.Black, ";\n  ");
        switch (e) {
          case g.Fill:
            return { accept: o, decline: o };
          case g.Outline:
            return { accept: r, decline: r };
          case g.Weighted:
          default:
            return { accept: o, decline: r };
        }
      })(null == n ? void 0 : n.buttonWeight, e.theme);
    return "\n    #"
      .concat(p.BannerWrapperId, " {\n      position: relative;\n    }\n    #")
      .concat(
        p.BannerWrapperId,
        ':after {\n      content: "";\n      display: block;\n      clear: both;\n    }\n    #'
      )
      .concat(
        p.BannerId,
        " {\n      box-shadow: 0px 4px 10px rgb(63 63 68 / 40%);\n      position: "
      )
      .concat(
        t ? "static" : "fixed",
        ";\n      z-index: 9999;\n      opacity: 1;\n      padding: 30px 40px;\n      background-color: "
      )
      .concat(o.banner, ";\n      ")
      .concat(i, "\n      display: flex;\n      flex-direction: ")
      .concat(
        t ? "column" : "row",
        ";\n      justify-content: space-between;\n      align-items: "
      )
      .concat(
        t ? "stretch" : "center",
        ";\n    }\n    @media only screen and (max-width: 900px) {\n      #"
      )
      .concat(
        p.BannerId,
        " {\n        align-items: stretch;\n        flex-direction: column;\n      }\n    }\n    #"
      )
      .concat(p.OverlayId, " {\n      ")
      .concat(r, "\n    }\n    #")
      .concat(
        p.BodyDivId,
        " {\n      margin-right: 5%;\n    }\n    @media only screen and (max-width: 900px) {\n      #"
      )
      .concat(
        p.BodyDivId,
        " {\n        margin-right: 0;\n      }\n    }\n    #"
      )
      .concat(p.DivId, " h3 {\n      color: ")
      .concat(
        o.bannerFont,
        ";\n      font-family: inherit;\n      font-size: 120%;\n      margin: 0 0 .5em 0;\n      padding: 0;\n      font-weight: bold;\n    }\n    #"
      )
      .concat(p.DivId, " p {\n      color: ")
      .concat(
        o.bannerFont,
        ";\n      font-family: inherit;\n      line-height: 1.3;\n      margin: 0;\n      padding: 0;\n    }\n    #"
      )
      .concat(p.DivId, " a {\n      color: ")
      .concat(
        o.bannerFont,
        ";\n      text-decoration: underline;\n    }\n    #"
      )
      .concat(
        p.DivId,
        " button {\n      border: none;\n      text-decoration: none;\n      font-family: inherit;\n      border-radius: 4px;\n      padding: 5px 20px;\n      margin: 15px 10px 0 0;\n      font-size: 100%;\n    }\n    #"
      )
      .concat(p.DivId, " button:hover {\n      cursor: pointer;\n    }\n    #")
      .concat(p.DivId, " button.")
      .concat(p.ButtonAcceptClass, " {\n      border: 2px solid ")
      .concat(o.buttonBorderColor, ";\n      ")
      .concat(c.accept, "\n      white-space: nowrap;\n    }\n    #")
      .concat(p.DivId, " button.")
      .concat(p.ButtonDeclineClass, " {\n      border: 2px solid ")
      .concat(o.buttonBorderColor, ";\n      ")
      .concat(c.decline, "\n      white-space: nowrap;\n    }\n    #")
      .concat(
        p.ButtonDivId,
        " {\n      display: flex;\n      justify-content: flex-start;\n      "
      )
      .concat(
        a,
        "\n    }\n    @media only screen and (max-width: 900px) {\n      #"
      )
      .concat(
        p.ButtonDivId,
        " {\n        justify-content: flex-end\n      }\n    }​"
      );
  }
  !(function (e) {
    (e.Black = "#333"),
      (e.White = "#fff"),
      (e.Gray = "#ccc"),
      (e.Green = "#3AA83A"),
      (e.LightGray = "#F7F8F9"),
      (e.DarkGray = "#36454F"),
      (e.VeryDarkGray = "#666"),
      (e.VeryLightGray = "#e5e5e5");
  })(d || (d = {})),
    (function (e) {
      (e.Accepted = "accept"),
        (e.Declined = "decline"),
        (e.PrivacyPolicyView = "privacy_policy_view");
    })(u || (u = {})),
    (function (e) {
      (e.StyleId = "shopify-privacy-banner-styles"),
        (e.DivId = "shopify-privacy-banner-div"),
        (e.BannerWrapperId = "shopify-privacy-banner-wrapper"),
        (e.BannerId = "shopify-privacy-banner"),
        (e.OverlayId = "shopify-privacy-banner-overlay"),
        (e.BodyDivId = "shopify-privacy-banner-body-div"),
        (e.PrivacyPolicyLinkId = "shopify-privacy-banner-privacy-policy"),
        (e.ButtonDivId = "shopify-privacy-banner-button-div"),
        (e.ButtonAcceptId = "shopify-privacy-banner-accept-button"),
        (e.ButtonAcceptClass = "accept"),
        (e.ButtonDeclineId = "shopify-privacy-banner-decline-button"),
        (e.ButtonDeclineClass = "decline"),
        (e.ButtonManageCookiesId =
          "shopify-privacy-banner-manage-cookies-button"),
        (e.ButtonManageCookiesClass = "manage");
    })(p || (p = {})),
    (function (e) {
      (e.StyleId = "manage-cookies-modal-styles"),
        (e.ModalWrapperId = "manage-cookies-modal-wrapper"),
        (e.ModalId = "manage-cookies-modal"),
        (e.BodyDivId = "manage-cookies-body"),
        (e.OverlayId = "manage-cookies-modal-overlay"),
        (e.ContentId = "manage-cookies-modal-content"),
        (e.DivId = "manage-cookies-banner-div"),
        (e.ButtonDivId = "manage-cookies-banner-button-div"),
        (e.ButtonAcceptId = "manage-cookies-banner-accept-button"),
        (e.ButtonAcceptClass = "acceptAll"),
        (e.ButtonDeclineId = "manage-cookies-banner-decline-button"),
        (e.ButtonDeclineClass = "declineAll"),
        (e.SaveAndCloseId = "manage-cookies-banner-save-and-close-button"),
        (e.SaveAndCloseClass = "SaveAndCloseClass"),
        (e.ButtonManageCookiesId =
          "manage-cookies-banner-manage-cookies-button"),
        (e.EssentialToggleId = "essential-toggle-id"),
        (e.EssentialToggleClass = "essential-toggle-class"),
        (e.MarketingToggleId = "marketing-toggle-id"),
        (e.MarketingToggleClass = "marketing-toggle-class"),
        (e.StatisticsToggleId = "analytics-toggle-id"),
        (e.StatisticsToggleClass = "analytics-toggle-class"),
        (e.PreferencesToggleId = "preferences-toggle-id"),
        (e.PreferencesToggleClass = "preferences-toggle-class"),
        (e.AttributionToggleId = "attribution-toggle-id"),
        (e.AttributionToggleClass = "attribution-toggle-class"),
        (e.ToggleDiv = "toggle-div"),
        (e.ToggleDivWrapper = "toggle-div-wrapper"),
        (e.ActionButtonClass = "manage-cookies-action-button-class"),
        (e.ToggleDefaultContent = "toggle-default-content"),
        (e.ToggleExpandedContent = "toggle-expanded-content");
    })(h || (h = {})),
    (function (e) {
      (e.BottomFullWidth = "bottom-full-width"),
        (e.BottomLeft = "bottom-left"),
        (e.Center = "center"),
        (e.BottomRight = "bottom-right"),
        (e.BottomCenter = "bottom-center");
    })(f || (f = {})),
    (function (e) {
      (e.AcceptFirst = "accept-first"), (e.DeclineFirst = "decline-first");
    })(m || (m = {})),
    (function (e) {
      (e.Fill = "fill"), (e.Outline = "outline"), (e.Weighted = "weighted");
    })(g || (g = {})),
    (function (e) {
      (e[(e.Yes = 1)] = "Yes"), (e[(e.No = 0)] = "No");
    })(y || (y = {})),
    (function (e) {
      (e.Dark = "dark"), (e.Light = "light");
    })(v || (v = {}));
  var I = (function () {
      function e() {}
      return (
        (e.getServerData = function () {
          return o(this, void 0, Promise, function () {
            var e, t, n, o, i;
            return r(this, function (r) {
              return (
                (e = window.Shopify.shop),
                "https://privacy-banner.shopifycloud.com",
                (t = this.shopCanExperiment()),
                (n = this.canonicalShopId()),
                (o = t && null != n ? "&experiment_shop_id=".concat(n) : ""),
                (i = ""
                  .concat(
                    "https://privacy-banner.shopifycloud.com",
                    "/customization?shopify_domain="
                  )
                  .concat(e)
                  .concat(o)),
                [2, this.getServerDataWithBackoff(i)]
              );
            });
          });
        }),
        (e.canonicalShopId = function () {
          var e, t, n, o;
          return null ===
            (o =
              null ===
                (n =
                  null ===
                    (t =
                      null === (e = window.trekkie) || void 0 === e
                        ? void 0
                        : e.config) || void 0 === t
                    ? void 0
                    : t.Trekkie) || void 0 === n
                ? void 0
                : n.defaultAttributes) || void 0 === o
            ? void 0
            : o.shopId;
        }),
        (e.shopCanExperiment = function () {
          var e,
            t,
            n = P("_tracking_consent");
          try {
            t = JSON.parse(decodeURIComponent(n));
          } catch (e) {
            return !1;
          }
          var o = null !== (e = t.lim) && void 0 !== e ? e : [];
          return o.includes("GDPR") && !o.includes("GDPR_BLOCK_ALL");
        }),
        (e.getServerDataWithBackoff = function (e, t) {
          return (
            void 0 === t && (t = 1),
            o(this, void 0, Promise, function () {
              var n, o, i;
              return r(this, function (r) {
                switch (r.label) {
                  case 0:
                    return (
                      (n = "".concat(e, "&request_attempt=").concat(t)),
                      [4, fetch(n)]
                    );
                  case 1:
                    return [4, (o = r.sent()).json()];
                  case 2:
                    return (
                      (i = r.sent()),
                      200 === o.status
                        ? [2, i]
                        : t < this.MAX_RETRIES
                        ? [4, this.wait()]
                        : [3, 4]
                    );
                  case 3:
                    return (
                      r.sent(), [2, this.getServerDataWithBackoff(e, t + 1)]
                    );
                  case 4:
                    throw new Error("Could not reach the server");
                }
              });
            })
          );
        }),
        (e.wait = function () {
          var e = this;
          return new Promise(function (t) {
            return setTimeout(t, e.TIME_BETWEEN_REQUESTS);
          });
        }),
        (e.MAX_RETRIES = 6),
        (e.TIME_BETWEEN_REQUESTS = 5e3),
        e
      );
    })(),
    D = function () {
      return (
        !window.location.pathname.match(/^(\/[a-z]{2}(-[A-Z]{2})?)?\/cart$/) &&
        void 0 !== window.Shopify &&
        void 0 !== window.Shopify.customerPrivacy &&
        "GDPR" === window.Shopify.customerPrivacy.getRegulation() &&
        window.Shopify.customerPrivacy.isRegulationEnforced() &&
        "no_interaction" === window.Shopify.customerPrivacy.getTrackingConsent()
      );
    },
    k = function () {
      return "1" === C("preview_privacy_banner");
    };
  function A(e) {
    return e &&
      e.__esModule &&
      Object.prototype.hasOwnProperty.call(e, "default")
      ? e.default
      : e;
  }
  function T(e, t) {
    return e((t = { exports: {} }), t.exports), t.exports;
  }
  var M = T(function (e, t) {
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.DEVELOPMENT_DOMAIN = "http://localhost:8082"),
      (t.PRODUCTION_DOMAIN = "https://monorail-edge.shopifysvc.com"),
      (t.PRODUCE_BATCH_ENDPOINT = "/unstable/produce_batch"),
      (t.PRODUCE_ENDPOINT = "/v1/produce"),
      (t.PRODUCTION_CANADA_ENDPOINT =
        "https://monorail-edge-ca.shopifycloud.com/v1/produce"),
      (t.extractDomain = function (e) {
        return "https://" + new URL(e).hostname;
      });
  });
  A(M),
    M.DEVELOPMENT_DOMAIN,
    M.PRODUCTION_DOMAIN,
    M.PRODUCE_BATCH_ENDPOINT,
    M.PRODUCE_ENDPOINT,
    M.PRODUCTION_CANADA_ENDPOINT,
    M.extractDomain;
  for (
    var W = T(function (e) {
        var t =
          ("undefined" != typeof crypto &&
            crypto.getRandomValues &&
            crypto.getRandomValues.bind(crypto)) ||
          ("undefined" != typeof msCrypto &&
            "function" == typeof window.msCrypto.getRandomValues &&
            msCrypto.getRandomValues.bind(msCrypto));
        if (t) {
          var n = new Uint8Array(16);
          e.exports = function () {
            return t(n), n;
          };
        } else {
          var o = new Array(16);
          e.exports = function () {
            for (var e, t = 0; t < 16; t++)
              0 == (3 & t) && (e = 4294967296 * Math.random()),
                (o[t] = (e >>> ((3 & t) << 3)) & 255);
            return o;
          };
        }
      }),
      O = [],
      S = 0;
    S < 256;
    ++S
  )
    O[S] = (S + 256).toString(16).substr(1);
  var F,
    N,
    R = function (e, t) {
      var n = t || 0,
        o = O;
      return [
        o[e[n++]],
        o[e[n++]],
        o[e[n++]],
        o[e[n++]],
        "-",
        o[e[n++]],
        o[e[n++]],
        "-",
        o[e[n++]],
        o[e[n++]],
        "-",
        o[e[n++]],
        o[e[n++]],
        "-",
        o[e[n++]],
        o[e[n++]],
        o[e[n++]],
        o[e[n++]],
        o[e[n++]],
        o[e[n++]],
      ].join("");
    },
    j = 0,
    L = 0;
  var U = function (e, t, n) {
    var o = (t && n) || 0,
      r = t || [],
      i = (e = e || {}).node || F,
      a = void 0 !== e.clockseq ? e.clockseq : N;
    if (null == i || null == a) {
      var c = W();
      null == i && (i = F = [1 | c[0], c[1], c[2], c[3], c[4], c[5]]),
        null == a && (a = N = 16383 & ((c[6] << 8) | c[7]));
    }
    var l = void 0 !== e.msecs ? e.msecs : new Date().getTime(),
      s = void 0 !== e.nsecs ? e.nsecs : L + 1,
      d = l - j + (s - L) / 1e4;
    if (
      (d < 0 && void 0 === e.clockseq && (a = (a + 1) & 16383),
      (d < 0 || l > j) && void 0 === e.nsecs && (s = 0),
      s >= 1e4)
    )
      throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    (j = l), (L = s), (N = a);
    var u = (1e4 * (268435455 & (l += 122192928e5)) + s) % 4294967296;
    (r[o++] = (u >>> 24) & 255),
      (r[o++] = (u >>> 16) & 255),
      (r[o++] = (u >>> 8) & 255),
      (r[o++] = 255 & u);
    var p = ((l / 4294967296) * 1e4) & 268435455;
    (r[o++] = (p >>> 8) & 255),
      (r[o++] = 255 & p),
      (r[o++] = ((p >>> 24) & 15) | 16),
      (r[o++] = (p >>> 16) & 255),
      (r[o++] = (a >>> 8) | 128),
      (r[o++] = 255 & a);
    for (var h = 0; h < 6; ++h) r[o + h] = i[h];
    return t || R(r);
  };
  var H = function (e, t, n) {
      var o = (t && n) || 0;
      "string" == typeof e &&
        ((t = "binary" === e ? new Array(16) : null), (e = null));
      var r = (e = e || {}).random || (e.rng || W)();
      if (((r[6] = (15 & r[6]) | 64), (r[8] = (63 & r[8]) | 128), t))
        for (var i = 0; i < 16; ++i) t[o + i] = r[i];
      return t || R(r);
    },
    V = H;
  (V.v1 = U), (V.v4 = H);
  var G = V,
    z = T(function (e, t) {
      Object.defineProperty(t, "__esModule", { value: !0 });
      var n = (function (e) {
        function t(n) {
          var o =
            e.call(
              this,
              "Error producing to the Monorail Edge. Response received: " +
                JSON.stringify(n)
            ) || this;
          return (o.response = n), Object.setPrototypeOf(o, t.prototype), o;
        }
        return b.__extends(t, e), t;
      })(Error);
      t.MonorailUnableToProduceError = n;
      var o = (function (e) {
        function t(n) {
          var o =
            e.call(
              this,
              "Error producing to the Monorail Edge. Response received: " +
                JSON.stringify(n)
            ) || this;
          return Object.setPrototypeOf(o, t.prototype), (o.response = n), o;
        }
        return b.__extends(t, e), t;
      })(Error);
      t.MonorailBatchProduceError = o;
      var r = (function (e) {
        function t(n) {
          var o =
            e.call(
              this,
              "Error completing request. A network failure may have prevented the request from completing. Error: " +
                n
            ) || this;
          return Object.setPrototypeOf(o, t.prototype), o;
        }
        return b.__extends(t, e), t;
      })(Error);
      t.MonorailRequestError = r;
      var i = (function (e) {
        function t(n) {
          var o = e.call(this, "" + n) || this;
          return Object.setPrototypeOf(o, t.prototype), o;
        }
        return b.__extends(t, e), t;
      })(Error);
      t.MonorailRetriesExceededError = i;
    });
  A(z),
    z.MonorailUnableToProduceError,
    z.MonorailBatchProduceError,
    z.MonorailRequestError,
    z.MonorailRetriesExceededError;
  var q = M,
    Y = z,
    J = T(function (e, t) {
      Object.defineProperty(t, "__esModule", { value: !0 });
      var n = (function () {
        function e(e) {
          void 0 === e && (e = q.DEVELOPMENT_DOMAIN), (this.edgeDomain = e);
        }
        return (
          (e.withEndpoint = function (t) {
            return new e(q.extractDomain(t));
          }),
          (e.getHeadersFromMetadata = function (e) {
            var t = {
              "Content-Type": "application/json; charset=utf-8",
              "X-Monorail-Edge-Event-Created-At-Ms": (
                (e && e.eventCreatedAtMs) ||
                Date.now()
              ).toString(),
              "X-Monorail-Edge-Event-Sent-At-Ms": Date.now().toString(),
              "X-Monorail-Edge-Client-Message-Id": (
                (e && e.clientMessageId) ||
                G.v4()
              ).toString(),
            };
            return e && e.userAgent && (t["User-Agent"] = e.userAgent), t;
          }),
          (e.prototype.produceBatch = function (t) {
            return b.__awaiter(this, void 0, void 0, function () {
              var n, o, r, i, a, c;
              return b.__generator(this, function (l) {
                switch (l.label) {
                  case 0:
                    (n = {
                      events: this.convertAllEventsToUnderscoreCase(t),
                      metadata: this.toUnderscoreCase(t.metadata),
                    }),
                      (l.label = 1);
                  case 1:
                    return (
                      l.trys.push([1, 3, , 4]),
                      [
                        4,
                        fetch(this.produceBatchEndpoint(), {
                          method: "post",
                          headers: e.getHeadersFromMetadata(t.metadata),
                          body: JSON.stringify(n),
                        }),
                      ]
                    );
                  case 2:
                    return (o = l.sent()), [3, 4];
                  case 3:
                    throw ((r = l.sent()), new Y.MonorailRequestError(r));
                  case 4:
                    return 207 !== o.status ? [3, 6] : [4, o.json()];
                  case 5:
                    throw ((i = l.sent()), new Y.MonorailBatchProduceError(i));
                  case 6:
                    return o.ok
                      ? [3, 8]
                      : ((a = Y.MonorailUnableToProduceError.bind),
                        (c = { status: o.status }),
                        [4, o.text()]);
                  case 7:
                    throw new (a.apply(Y.MonorailUnableToProduceError, [
                      void 0,
                      ((c.message = l.sent()), c),
                    ]))();
                  case 8:
                    return [2, { status: o.status }];
                }
              });
            });
          }),
          (e.prototype.produce = function (t) {
            return b.__awaiter(this, void 0, void 0, function () {
              var n, o, r, i, a;
              return b.__generator(this, function (c) {
                switch (c.label) {
                  case 0:
                    (n = {
                      schema_id: t.schemaId,
                      payload: this.toUnderscoreCase(t.payload),
                    }),
                      (c.label = 1);
                  case 1:
                    return (
                      c.trys.push([1, 3, , 4]),
                      [
                        4,
                        fetch(this.produceEndpoint(), {
                          method: "post",
                          headers: e.getHeadersFromMetadata(t.metadata),
                          body: JSON.stringify(n),
                        }),
                      ]
                    );
                  case 2:
                    return (o = c.sent()), [3, 4];
                  case 3:
                    throw ((r = c.sent()), new Y.MonorailRequestError(r));
                  case 4:
                    if (!o)
                      throw new Y.MonorailUnableToProduceError({
                        message: "No response from edge",
                      });
                    return o.ok
                      ? [3, 6]
                      : ((i = Y.MonorailUnableToProduceError.bind),
                        (a = { status: o.status }),
                        [4, o.text()]);
                  case 5:
                    throw new (i.apply(Y.MonorailUnableToProduceError, [
                      void 0,
                      ((a.message = c.sent()), a),
                    ]))();
                  case 6:
                    return [2, { status: o.status }];
                }
              });
            });
          }),
          (e.prototype.produceBatchEndpoint = function () {
            return this.edgeDomain + q.PRODUCE_BATCH_ENDPOINT;
          }),
          (e.prototype.produceEndpoint = function () {
            return this.edgeDomain + q.PRODUCE_ENDPOINT;
          }),
          (e.prototype.convertAllEventsToUnderscoreCase = function (e) {
            var t = this;
            return e.events.map(function (e) {
              return {
                schema_id: e.schemaId,
                payload: t.toUnderscoreCase(e.payload),
                metadata: t.toUnderscoreCase(e.metadata),
              };
            });
          }),
          (e.prototype.toUnderscoreCase = function (e) {
            var t = this;
            return e
              ? Object.keys(e)
                  .map(function (n) {
                    var o;
                    return (
                      ((o = {})[t.convertStringToUnderscoreCase(n)] = e[n]), o
                    );
                  })
                  .reduce(function (e, t) {
                    return b.__assign({}, e, t);
                  })
              : e;
          }),
          (e.prototype.convertStringToUnderscoreCase = function (e) {
            return e
              .split(/(?=[A-Z])/)
              .join("_")
              .toLowerCase();
          }),
          e
        );
      })();
      t.HttpProducer = n;
    });
  A(J), J.HttpProducer;
  var X = T(function (e, t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n = (function () {
      function e(t) {
        (this.sendToConsole = t), t && e.printWelcomeMessage(t);
      }
      return (
        (e.printWelcomeMessage = function (e) {
          console.log(
            "%c👋 from Monorail%c\n\nWe've noticed that you're" +
              (e ? "" : " not") +
              " running in debug mode. As such, we will " +
              (e ? "produce" : "not produce") +
              " Monorail events to the console. \n\nIf you want Monorail events to " +
              (e ? "stop" : "start") +
              " appearing here, %cset debugMode=" +
              (!e).toString() +
              "%c, for the Monorail Log Producer in your code.",
            "font-size: large;",
            "font-size: normal;",
            "font-weight: bold;",
            "font-weight: normal;"
          );
        }),
        (e.prototype.produce = function (e) {
          return (
            this.sendToConsole && console.log("Monorail event produced", e),
            new Promise(function (t) {
              t(e);
            })
          );
        }),
        (e.prototype.produceBatch = function (e) {
          return (
            this.sendToConsole &&
              console.log("Monorail Batch event produced", e),
            new Promise(function (t) {
              t(e);
            })
          );
        }),
        e
      );
    })();
    t.LogProducer = n;
  });
  A(X), X.LogProducer;
  var K = T(function (e, t) {
    Object.defineProperty(t, "__esModule", { value: !0 }),
      (t.isCompositeMonorailEvent = function (e) {
        return void 0 !== e.schemaId;
      });
  });
  A(K), K.isCompositeMonorailEvent;
  var Q = K,
    Z = T(function (e, t) {
      Object.defineProperty(t, "__esModule", { value: !0 });
      var n = (function () {
        function e(e) {
          this.producer = e;
        }
        return (
          (e.prototype.do = function (e, t) {
            return Q.isCompositeMonorailEvent(e)
              ? this.producer.produce(e)
              : this.producer.produceBatch(e);
          }),
          e
        );
      })();
      t.ProducerMiddleware = n;
    });
  A(Z), Z.ProducerMiddleware;
  var $ = J,
    ee = X,
    te = Z,
    ne = T(function (e, t) {
      Object.defineProperty(t, "__esModule", { value: !0 });
      var n = (function () {
        function e(t, n) {
          (this.producer = t),
            (this.middleware = n),
            (this.executeChain = e.buildMiddlewareChain(
              this.middleware.concat(new te.ProducerMiddleware(t))
            ));
        }
        return (
          (e.createLogProducer = function (t) {
            return new e(new ee.LogProducer(t.debugMode), t.middleware || []);
          }),
          (e.createHttpProducerWithEndpoint = function (t, n) {
            return (
              void 0 === n && (n = []), new e($.HttpProducer.withEndpoint(t), n)
            );
          }),
          (e.createHttpProducer = function (t) {
            return new e(
              t.production
                ? new $.HttpProducer(q.PRODUCTION_DOMAIN)
                : new $.HttpProducer(q.DEVELOPMENT_DOMAIN),
              t.middleware || []
            );
          }),
          (e.buildMiddlewareChain = function (e, t) {
            var n = this;
            return (
              void 0 === t && (t = 0),
              t === e.length
                ? this.identityFn
                : function (o) {
                    return e[t].do(o, n.buildMiddlewareChain(e, t + 1));
                  }
            );
          }),
          (e.prototype.produce = function (e) {
            return (
              (e.metadata = b.__assign(
                { eventCreatedAtMs: Date.now(), clientMessageId: G.v4() },
                e.metadata
              )),
              this.executeChain(e)
            );
          }),
          (e.prototype.produceBatch = function (e) {
            return this.executeChain(e);
          }),
          e
        );
      })();
      t.Monorail = n;
    });
  A(ne), ne.Monorail;
  var oe = T(function (e, t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var n = (function () {
      function e(e, t) {
        void 0 === e && (e = 3),
          void 0 === t && (t = 150),
          (this.maxRetries = e),
          (this.delayMs = t);
      }
      return (
        (e.prototype.do = function (e, t) {
          return b.__awaiter(this, void 0, void 0, function () {
            var n, o, r, i, a;
            return b.__generator(this, function (c) {
              switch (c.label) {
                case 0:
                  (n = 0), (c.label = 1);
                case 1:
                  if (!(n < this.maxRetries)) return [3, 7];
                  (r = void 0), (c.label = 2);
                case 2:
                  return c.trys.push([2, 4, , 6]), [4, t(e)];
                case 3:
                  return (r = c.sent()), [3, 6];
                case 4:
                  if (
                    ((i = c.sent()),
                    (o = o || new Error()),
                    (o = new Error(
                      o.message +
                        " Retry count:" +
                        (n + 1) +
                        " Error msg:" +
                        i.message +
                        "\n"
                    )),
                    i instanceof Y.MonorailUnableToProduceError &&
                      (a = i.response.status) &&
                      a >= 400 &&
                      a < 500)
                  )
                    throw i;
                  return [4, this.delay(this.delayMs * Math.pow(2, n))];
                case 5:
                  return c.sent(), n++, [3, 1];
                case 6:
                  return [2, r];
                case 7:
                  throw (
                    (o
                      ? (o.message =
                          "Retry count of " +
                          this.maxRetries +
                          " exceeded. Failed with error: \n" +
                          o.message +
                          " Aborting request for " +
                          JSON.stringify(e))
                      : (o = new Error()),
                    new Y.MonorailRetriesExceededError(o))
                  );
              }
            });
          });
        }),
        (e.prototype.delay = function (e) {
          return new Promise(function (t) {
            return setTimeout(t, e);
          });
        }),
        e
      );
    })();
    t.RetryMiddleware = n;
  });
  A(oe), oe.RetryMiddleware;
  var re = ne,
    ie = oe,
    ae = T(function (e, t) {
      Object.defineProperty(t, "__esModule", { value: !0 }),
        (t.Monorail = re.Monorail),
        (t.MonorailRequestError = Y.MonorailRequestError),
        (t.MonorailUnableToProduceError = Y.MonorailUnableToProduceError),
        (t.MonorailRetriesExceededError = Y.MonorailRetriesExceededError),
        (t.RetryMiddleware = ie.RetryMiddleware);
    });
  A(ae);
  var ce = ae.Monorail;
  ae.MonorailRequestError,
    ae.MonorailUnableToProduceError,
    ae.MonorailRetriesExceededError,
    ae.RetryMiddleware;
  var le,
    se,
    de = (function () {
      function e() {
        (this.VISIT_TOKEN = "_shopify_s"),
          (this.monorail = ce.createHttpProducer({ production: !0 }));
      }
      return (
        (e.prototype.emitInteraction = function (e) {
          var t = this.getCommonPayload();
          this.monorail.produce({
            schemaId: "privacy_banner_interact/1.0",
            payload: n(n({}, t), { interactionType: e }),
          });
        }),
        (e.prototype.emitRender = function () {
          var e = this.getCommonPayload();
          this.monorail.produce({
            schemaId: "privacy_banner_render/1.0",
            payload: n({}, e),
          });
        }),
        (e.prototype.getCommonPayload = function () {
          return {
            shopPermanentDomain: window.Shopify.shop,
            sessionToken: P(this.VISIT_TOKEN) || "0",
            regulation: window.Shopify.customerPrivacy.getRegulation(),
            path: window.location.pathname,
          };
        }),
        e
      );
    })(),
    ue = (function () {
      function e(e, t) {
        (this.experimentId = ""),
          (this.experimentAssignment = ""),
          (this.experimentConfig = e),
          this.setExperimentIds(t);
      }
      return (
        (e.prototype.getBannerProperties = function () {
          var e = this.getExperimentAssignment();
          return e
            ? {
                bannerPlacement: e.bannerPlacement,
                buttonPlacement: e.buttonPlacement,
                buttonWeight: e.buttonWeight,
                overlay: e.overlay,
              }
            : null;
        }),
        (e.prototype.getBannerData = function () {
          var e = this.getExperimentAssignment();
          return e
            ? {
                acceptButtonCopy: e.acceptButtonCopy || "",
                declineButtonCopy: e.declineButtonCopy || "",
                title: e.title || "",
                bannerCopy: e.bannerCopy || "",
              }
            : null;
        }),
        (e.prototype.getExperimentAssignment = function () {
          var e = this;
          if (this.experimentId && this.experimentAssignment) {
            var t = w(this.experimentConfig, function (t) {
              return t.id === e.experimentId;
            });
            return w(null == t ? void 0 : t.assignments, function (t) {
              return t.id === e.experimentAssignment;
            });
          }
          return null;
        }),
        (e.prototype.setExperimentIds = function (e) {
          var t,
            n,
            o = (null == e ? void 0 : e.experiments) || [],
            r = null === (t = o[0]) || void 0 === t ? void 0 : t.experimentId,
            i =
              null === (n = o[0]) || void 0 === n
                ? void 0
                : n.experimentAssignment,
            a = C("experiment-id"),
            c = C("experiment-assignment");
          (this.experimentId = a || r), (this.experimentAssignment = c || i);
        }),
        e
      );
    })();
  !(function (e) {
    (e.Example = "example"),
      (e.BannerPlacement = "customer_privacy_banner_placement_experiment"),
      (e.BannerPlacementV2 = "customer_privacy_banner_placement_experiment_v2"),
      (e.BannerBodyCopy = "customer_privacy_body_copy_experiment"),
      (e.CtaPlacement = "customer_privacy_button_placement_experiment"),
      (e.CtaContent = "customer_privacy_button_content_experiment"),
      (e.CtaWeight = "customer_privacy_button_weight_experiment"),
      (e.BannerHeadline = "customer_privacy_headline_content_experiment"),
      (e.BannerOverlay = "customer_privacy_overlay_effect_experiment");
  })(le || (le = {})),
    (function (e) {
      (e.Example1 = "1"),
        (e.Example2 = "2"),
        (e.Example3 = "3"),
        (e.Example4 = "4"),
        (e.Example5 = "5"),
        (e.Example6 = "6"),
        (e.Example7 = "7"),
        (e.Example8 = "8"),
        (e.Example9 = "9"),
        (e.BannerPlacementFullWidth = "control"),
        (e.BannerPlacementCenter = "test_group_a"),
        (e.BannerPlacementBottomLeft = "test_group_b"),
        (e.BannerPlacementBottomRight = "test_group_c"),
        (e.BannerPlacementV2FullWidth = "control"),
        (e.BannerPlacementV2Center = "test_group_a"),
        (e.BannerPlacementV2BottomLeft = "test_group_b"),
        (e.BannerPlacementV2BottomCenter = "test_group_c"),
        (e.BannerBodyCopyMinimalText = "control"),
        (e.BannerBodyCopyMoreDetails = "test_group_a"),
        (e.BannerBodyCopyMoreTechnicalAndLegalDetails = "test_group_b"),
        (e.CtaPlacementAcceptFirst = "control"),
        (e.CtaPlacementDeclineFirst = "test"),
        (e.CtaContentConversational = "control"),
        (e.CtaContentUnambiguous = "test_group_a"),
        (e.CtaContentPersonallyDriven = "test_group_b"),
        (e.CtaWeightWeighted = "control"),
        (e.CtaWeightFill = "test_group_a"),
        (e.CtaWeightOutline = "test_group_b"),
        (e.BannerHeadlineUserEmpathy = "control"),
        (e.BannerHeadlinePersonalizedWithShopName = "test_group_a"),
        (e.BannerHeadlineNoHeadline = "test_group_b"),
        (e.BannerOverlayNo = "control"),
        (e.BannerOverlayYes = "test");
    })(se || (se = {}));
  var pe,
    he = [
      {
        id: le.Example,
        assignments: [
          {
            id: se.Example1,
            desc: "",
            bannerPlacement: f.BottomFullWidth,
            buttonPlacement: m.AcceptFirst,
            buttonWeight: g.Weighted,
            overlay: y.Yes,
          },
          {
            id: se.Example2,
            desc: "",
            bannerPlacement: f.Center,
            buttonPlacement: m.DeclineFirst,
            buttonWeight: g.Outline,
            overlay: y.Yes,
          },
          {
            id: se.Example3,
            desc: "",
            bannerPlacement: f.BottomLeft,
            buttonPlacement: m.AcceptFirst,
            buttonWeight: g.Fill,
            overlay: y.Yes,
          },
          {
            id: se.Example4,
            desc: "",
            bannerPlacement: f.BottomFullWidth,
            buttonPlacement: m.AcceptFirst,
            buttonWeight: g.Fill,
            overlay: y.No,
          },
          {
            id: se.Example5,
            desc: "",
            bannerPlacement: f.Center,
            buttonPlacement: m.AcceptFirst,
            buttonWeight: g.Fill,
            overlay: y.No,
          },
          {
            id: se.Example6,
            desc: "",
            bannerPlacement: f.BottomLeft,
            buttonPlacement: m.DeclineFirst,
            buttonWeight: g.Outline,
            overlay: y.No,
          },
          {
            id: se.Example7,
            desc: "",
            bannerPlacement: f.BottomRight,
            buttonPlacement: m.AcceptFirst,
            buttonWeight: g.Fill,
            overlay: y.Yes,
          },
          {
            id: se.Example8,
            desc: "",
            bannerPlacement: f.BottomRight,
            buttonPlacement: m.AcceptFirst,
            buttonWeight: g.Fill,
            overlay: y.No,
          },
          {
            id: se.Example9,
            desc: "",
            bannerPlacement: f.BottomRight,
            buttonPlacement: m.DeclineFirst,
            buttonWeight: g.Outline,
            overlay: y.No,
          },
        ],
      },
      {
        id: le.BannerBodyCopy,
        assignments: [
          {
            id: se.BannerBodyCopyMinimalText,
            desc: "Control: Minimal text in the body",
            bannerPlacement: f.BottomFullWidth,
            buttonPlacement: m.AcceptFirst,
            buttonWeight: g.Weighted,
            overlay: y.No,
            acceptButtonCopy: "Accept",
            declineButtonCopy: "Do not accept",
            bannerCopy:
              "We use cookies and similar technologies to provide the best experience on our website.",
          },
          {
            id: se.BannerBodyCopyMoreDetails,
            desc: "More details regarding data collection and usage in the body",
            bannerPlacement: f.BottomFullWidth,
            buttonPlacement: m.AcceptFirst,
            buttonWeight: g.Weighted,
            overlay: y.No,
            acceptButtonCopy: "Accept",
            declineButtonCopy: "Do not accept",
            bannerCopy:
              'We and our partners use technologies, which may be stored on your device, and process personal data like IP addresses or device identifiers on our platforms. If you\'re OK with this, please click "Accept." If you\'re not, you can click "Do not accept."',
          },
          {
            id: se.BannerBodyCopyMoreTechnicalAndLegalDetails,
            desc: "More technical and legal details compared to the other two variants",
            bannerPlacement: f.BottomFullWidth,
            buttonPlacement: m.AcceptFirst,
            buttonWeight: g.Weighted,
            overlay: y.No,
            acceptButtonCopy: "Accept",
            declineButtonCopy: "Do not accept",
            bannerCopy:
              'We and our partners use technologies, such as cookies stored on your device, and process personal data like IP addresses or device identifiers on our platforms. We use this data to analyze how our website is used and provide you with personalized advertising. If you\'re OK with this, please click "Accept." If you\'re not, you can click "Do not accept."',
          },
        ],
      },
      {
        id: le.BannerHeadline,
        assignments: [
          {
            id: se.BannerHeadlineUserEmpathy,
            desc: "Control: Sense of user empathy in the headline",
            bannerPlacement: f.BottomFullWidth,
            buttonPlacement: m.AcceptFirst,
            buttonWeight: g.Weighted,
            overlay: y.No,
          },
          {
            id: se.BannerHeadlinePersonalizedWithShopName,
            desc: "More personalized headline that contains the shop name",
            bannerPlacement: f.BottomFullWidth,
            buttonPlacement: m.AcceptFirst,
            buttonWeight: g.Weighted,
            overlay: y.No,
          },
          {
            id: se.BannerHeadlineNoHeadline,
            desc: "Without any headlines",
            bannerPlacement: f.BottomFullWidth,
            buttonPlacement: m.AcceptFirst,
            buttonWeight: g.Weighted,
            overlay: y.No,
          },
        ],
      },
      {
        id: le.BannerOverlay,
        assignments: [
          {
            id: se.BannerOverlayNo,
            desc: "Control: Allows the user to interact with the site - no overlay",
            bannerPlacement: f.BottomFullWidth,
            buttonPlacement: m.AcceptFirst,
            buttonWeight: g.Weighted,
            overlay: y.No,
          },
          {
            id: se.BannerOverlayYes,
            desc: "Translucent overlay which obstructs site content",
            bannerPlacement: f.BottomFullWidth,
            buttonPlacement: m.AcceptFirst,
            buttonWeight: g.Weighted,
            overlay: y.Yes,
          },
        ],
      },
      {
        id: le.BannerPlacement,
        assignments: [
          {
            id: se.BannerPlacementFullWidth,
            desc: "Control: Full width bottom",
            bannerPlacement: f.BottomFullWidth,
            buttonPlacement: m.AcceptFirst,
            buttonWeight: g.Weighted,
            overlay: y.No,
          },
          {
            id: se.BannerPlacementCenter,
            desc: "Center aligned",
            bannerPlacement: f.Center,
            buttonPlacement: m.AcceptFirst,
            buttonWeight: g.Weighted,
            overlay: y.No,
          },
          {
            id: se.BannerPlacementBottomLeft,
            desc: "Bottom left",
            bannerPlacement: f.BottomLeft,
            buttonPlacement: m.AcceptFirst,
            buttonWeight: g.Weighted,
            overlay: y.No,
          },
          {
            id: se.BannerPlacementBottomRight,
            desc: "Bottom right",
            bannerPlacement: f.BottomRight,
            buttonPlacement: m.AcceptFirst,
            buttonWeight: g.Weighted,
            overlay: y.No,
          },
        ],
      },
      {
        id: le.BannerPlacementV2,
        assignments: [
          {
            id: se.BannerPlacementV2FullWidth,
            desc: "Control: Full width bottom",
            bannerPlacement: f.BottomFullWidth,
            buttonPlacement: m.AcceptFirst,
            buttonWeight: g.Weighted,
            overlay: y.No,
          },
          {
            id: se.BannerPlacementV2Center,
            desc: "Center aligned",
            bannerPlacement: f.Center,
            buttonPlacement: m.AcceptFirst,
            buttonWeight: g.Weighted,
            overlay: y.No,
          },
          {
            id: se.BannerPlacementV2BottomLeft,
            desc: "Bottom left",
            bannerPlacement: f.BottomLeft,
            buttonPlacement: m.AcceptFirst,
            buttonWeight: g.Weighted,
            overlay: y.No,
          },
          {
            id: se.BannerPlacementV2BottomCenter,
            desc: "Bottom center",
            bannerPlacement: f.BottomCenter,
            buttonPlacement: m.AcceptFirst,
            buttonWeight: g.Weighted,
            overlay: y.No,
          },
        ],
      },
      {
        id: le.CtaContent,
        assignments: [
          {
            id: se.CtaContentConversational,
            desc: 'Control: "Ok" and "No, thank you" - Conversational',
            bannerPlacement: f.BottomFullWidth,
            buttonPlacement: m.AcceptFirst,
            buttonWeight: g.Weighted,
            overlay: y.No,
            acceptButtonCopy: "Ok",
            declineButtonCopy: "No Thanks",
          },
          {
            id: se.CtaContentUnambiguous,
            desc: 'Unambiguous "Accept" and "Do not accept"',
            bannerPlacement: f.BottomFullWidth,
            buttonPlacement: m.AcceptFirst,
            buttonWeight: g.Weighted,
            overlay: y.No,
            acceptButtonCopy: "Accept",
            declineButtonCopy: "Do not accept",
          },
          {
            id: se.CtaContentPersonallyDriven,
            desc: 'Personally driven "Yes, I agree" and "No, I decline"',
            bannerPlacement: f.BottomFullWidth,
            buttonPlacement: m.AcceptFirst,
            buttonWeight: g.Weighted,
            overlay: y.No,
            acceptButtonCopy: "Yes, I agree",
            declineButtonCopy: "No, I decline",
          },
        ],
      },
      {
        id: le.CtaPlacement,
        assignments: [
          {
            id: se.CtaPlacementAcceptFirst,
            desc: "Control: Accept button on the left side of the banner and decline button on the right",
            bannerPlacement: f.BottomFullWidth,
            buttonPlacement: m.AcceptFirst,
            buttonWeight: g.Weighted,
            overlay: y.No,
          },
          {
            id: se.CtaPlacementDeclineFirst,
            desc: "Accept button on the right side of the banner and decline button on the left",
            bannerPlacement: f.BottomFullWidth,
            buttonPlacement: m.DeclineFirst,
            buttonWeight: g.Weighted,
            overlay: y.No,
          },
        ],
      },
      {
        id: le.CtaWeight,
        assignments: [
          {
            id: se.CtaWeightWeighted,
            desc: 'Control: Weighted - Filled "Ok" button',
            bannerPlacement: f.BottomFullWidth,
            buttonPlacement: m.AcceptFirst,
            buttonWeight: g.Weighted,
            overlay: y.No,
          },
          {
            id: se.CtaWeightFill,
            desc: 'Both "accept" and "decline" buttons filled',
            bannerPlacement: f.BottomFullWidth,
            buttonPlacement: m.AcceptFirst,
            buttonWeight: g.Fill,
            overlay: y.No,
          },
          {
            id: se.CtaWeightOutline,
            desc: 'Both "accept" and "decline" buttons outlined',
            bannerPlacement: f.BottomFullWidth,
            buttonPlacement: m.AcceptFirst,
            buttonWeight: g.Outline,
            overlay: y.No,
          },
        ],
      },
    ];
  function fe(e, t) {
    return (
      (null == t ? void 0 : t.id) && e.setAttribute("id", t.id),
      (null == t ? void 0 : t.class) && e.setAttribute("class", t.class),
      (null == t ? void 0 : t.onClick) &&
        e.addEventListener("click", t.onClick),
      e
    );
  }
  function me(e) {
    var t = fe(document.createElement("div"), e);
    return (null == e ? void 0 : e.text) && (t.textContent = e.text), t;
  }
  function ge(e) {
    var t = fe(document.createElement("button"), e);
    return (
      (t.textContent = e.text), e.disabled && t.setAttribute("disabled", ""), t
    );
  }
  function ye(e) {
    var t = fe(document.createElement("p"), e);
    return (t.textContent = e.text), t;
  }
  function ve(e, t) {
    var n = fe(document.createElement(e), t);
    return (n.textContent = t.text), n;
  }
  function be(e) {
    var t = fe(document.createElement("style"), e);
    return (t.innerHTML = e.content), t;
  }
  function we() {
    var e = me({ id: h.ModalWrapperId }),
      t = me({ id: h.OverlayId, text: "&nbsp;" });
    e.appendChild(t);
    var n = me({ id: h.ModalId });
    e.appendChild(n);
    var o = me({ id: h.BodyDivId });
    n.appendChild(o);
    var r = me({ id: h.ButtonDivId });
    n.appendChild(r);
    var i = me({ class: h.ActionButtonClass });
    r.appendChild(i),
      (function (e) {
        var t = ((n = { text: "Manage Cookie Settings" }), ve(pe.H1, n));
        var n;
        e.appendChild(t);
      })(o),
      (function (e) {
        var t = ye({
          text: "You can exercise choice and determine how your information is used for the purposes below by switching the consent toggles on or off. Please note that some of our partners do not require consent to process your personal information, but you have a right to object to such processing.",
        });
        e.appendChild(t);
      })(o);
    var a = me({ id: h.ToggleDivWrapper });
    return (
      o.appendChild(a),
      Ce(
        h.EssentialToggleId,
        h.EssentialToggleClass,
        "Allow data use for essential purposes",
        "Essential Cookies are mandaeetory to help the site function.",
        a,
        0
      ),
      Ce(
        h.MarketingToggleId,
        h.MarketingToggleClass,
        "Allow data use for marketing analytics",
        "These cookies help companies track you and sell to you.",
        a,
        1
      ),
      Ce(
        h.StatisticsToggleId,
        h.StatisticsToggleClass,
        "Allow data use for statistics analytics",
        "These cookies tell you how fast your website is.",
        a,
        2
      ),
      Ce(
        h.PreferencesToggleId,
        h.PreferencesToggleClass,
        "Allow data use for preferences analytics",
        "These cookies help us know what you like to do on your site.",
        a,
        3
      ),
      Ce(
        h.AttributionToggleId,
        h.AttributionToggleClass,
        "Allow data use for attribution analytics",
        "These cookies help us track your sites sale conversion.",
        a,
        4
      ),
      i.appendChild(
        ge({
          id: h.ButtonAcceptId,
          class: h.ButtonAcceptClass,
          text: "Accept All",
          onClick: function () {
            window.Shopify.customerPrivacy.setTrackingConsent(!0, Pe);
          },
        })
      ),
      (function (e) {
        e.appendChild(
          ge({
            id: h.ButtonDeclineId,
            class: h.ButtonDeclineClass,
            text: "Decline All",
            onClick: function () {
              window.Shopify.customerPrivacy.setTrackingConsent(!1, Pe);
            },
          })
        );
      })(i),
      (function (e) {
        e.appendChild(
          ge({
            id: h.SaveAndCloseId,
            class: h.SaveAndCloseClass,
            text: "Save & Close",
            onClick: function () {
              var e = document.getElementById(h.MarketingToggleId),
                t = document.getElementById(h.StatisticsToggleId),
                n = document.getElementById(h.PreferencesToggleId),
                o = document.getElementById(h.AttributionToggleId);
              window.Shopify.customerPrivacy.setTrackingConsent(
                {
                  marketing: e.checked,
                  statistics: t.checked,
                  preferences: n.checked,
                  attribution: o.checked,
                },
                Pe
              );
            },
          })
        );
      })(i),
      e
    );
  }
  function Ce(e, t, n, o, r, i) {
    var a = me({
        id: "".concat(h.ToggleDiv, "-").concat(i),
        class: h.ToggleDiv,
        onClick: function () {
          var e;
          null ===
            (e = document.getElementById(
              "".concat(h.ToggleDiv, "-").concat(i)
            )) ||
            void 0 === e ||
            e.classList.toggle("active");
        },
      }),
      c = me({ class: h.ToggleDefaultContent }),
      l = me({ class: h.ToggleExpandedContent, text: o }),
      s = me({ class: "desc", text: n }),
      u = (function (e) {
        var t = fe(document.createElement("input"), e);
        return (
          t.setAttribute("type", e.type),
          e.checked && t.setAttribute("checked", "true"),
          e.disabled && t.setAttribute("disabled", "".concat(e.disabled)),
          t
        );
      })({ id: e, class: t, type: "checkbox", checked: !1 }),
      p = (function (e) {
        var t = fe(document.createElement("label"), e);
        return t.setAttribute("for", e.for), t;
      })({ class: "switch", for: e }),
      f = (function (e) {
        var t = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        t.setAttributeNS(null, "width", e.width),
          t.setAttributeNS(null, "height", e.height),
          t.setAttributeNS(
            null,
            "viewBox",
            "0 0 ".concat(e.width, " ").concat(e.height)
          );
        var n = document.createElementNS("http://www.w3.org/2000/svg", "path");
        return (
          n.setAttributeNS(
            null,
            "fill",
            (null == e ? void 0 : e.colour) || "#000"
          ),
          n.setAttributeNS(null, "d", e.path),
          t.appendChild(n),
          t
        );
      })({
        width: "24",
        height: "24",
        path: "M0 11.522l1.578-1.626 7.734 4.619 13.335-12.526 1.353 1.354-14 18.646z",
        colour: d.Green,
      });
    c.appendChild(s),
      t === h.EssentialToggleClass
        ? c.appendChild(f)
        : (c.appendChild(u), c.appendChild(p)),
      a.appendChild(c),
      a.appendChild(l),
      r.appendChild(a);
  }
  function Pe() {
    var e = document.getElementById(h.DivId);
    null !== e &&
      (document.body.style.removeProperty("overflow"),
      (e.style.display = "none"));
  }
  function Be() {
    var e = document.getElementById(h.DivId);
    null !== e &&
      ((e.style.display = "block"),
      document.body.style.setProperty("overflow", "hidden"));
  }
  function xe(e, t) {
    void 0 === t && (t = !1);
    var n = me({ id: p.BannerWrapperId }),
      o = me({ id: p.BannerId });
    n.appendChild(o);
    var r = me({ id: p.OverlayId, text: "&nbsp;" });
    n.appendChild(r);
    var i = me({ id: p.BodyDivId });
    o.appendChild(i);
    var a,
      c = me({ id: p.ButtonDivId });
    return (
      o.appendChild(c),
      (function (e, t) {
        if (e.title) {
          var n = ((o = { text: e.title }), ve(pe.H3, o));
          t.appendChild(n);
        }
        var o;
      })(e, i),
      (function (e, t) {
        var n = ye({ text: "".concat(e.bannerCopy, " ") }),
          o = (function (e) {
            var t = fe(document.createElement("a"), e);
            return (
              t.setAttribute("href", e.href),
              (t.textContent = e.text),
              t.setAttribute(
                "target",
                void 0 === e.target ? "_blank" : e.target
              ),
              t
            );
          })({
            id: p.PrivacyPolicyLinkId,
            href: e.policyLink,
            target: "_blank",
            text: e.policyTitle ? e.policyTitle : "Privacy Policy",
          });
        n.appendChild(o), t.appendChild(n);
      })(e, i),
      (function (e, t, n) {
        t.appendChild(
          ge({
            disabled: n,
            id: p.ButtonAcceptId,
            class: p.ButtonAcceptClass,
            text: e.acceptButtonCopy,
          })
        );
      })(e, c, t),
      (a = P("_tracking_consent")) && "2.1" === JSON.parse(a).v
        ? (function (e, t) {
            e.appendChild(
              ge({
                id: p.ButtonManageCookiesId,
                class: p.ButtonManageCookiesClass,
                disabled: t,
                text: "Manage my cookies",
              })
            );
          })(c, t)
        : (function (e, t, n) {
            t.appendChild(
              ge({
                disabled: n,
                id: p.ButtonDeclineId,
                class: p.ButtonDeclineClass,
                text: e.declineButtonCopy,
              })
            );
          })(e, c, t),
      n
    );
  }
  !(function (e) {
    (e.H1 = "h1"), (e.H2 = "h2"), (e.H3 = "h3");
  })(pe || (pe = {}));
  var _e = (function () {
    function e() {
      (this.bannerProperties = {
        bannerPlacement: f.BottomFullWidth,
        buttonPlacement: m.AcceptFirst,
        buttonWeight: g.Weighted,
        overlay: y.No,
      }),
        (this.logger = new de());
    }
    return (
      (e.prototype.init = function () {
        return o(this, void 0, void 0, function () {
          var e, t, n, o, i;
          return r(this, function (r) {
            switch (r.label) {
              case 0:
                return this.removeExistingElements(), [4, I.getServerData()];
              case 1:
                return (
                  (e = r.sent()),
                  (t = new ue(he, e)),
                  (n = t.getBannerProperties()),
                  (o = t.getBannerData()),
                  this.setBannerProperties(n),
                  (i = this.setBannerData(e, o)),
                  this.render(i),
                  [2]
                );
            }
          });
        });
      }),
      (e.prototype.hide = function () {
        var e = document.getElementById(p.DivId);
        null !== e && (e.style.display = "none");
      }),
      (e.prototype.show = function () {
        var e = document.getElementById(p.DivId);
        null !== e && (e.style.display = "block");
      }),
      (e.prototype.setBannerProperties = function (e) {
        (null == e ? void 0 : e.bannerPlacement) &&
          (this.bannerProperties.bannerPlacement = e.bannerPlacement),
          (null == e ? void 0 : e.buttonPlacement) &&
            (this.bannerProperties.buttonPlacement = e.buttonPlacement),
          (null == e ? void 0 : e.buttonWeight) &&
            (this.bannerProperties.buttonWeight = e.buttonWeight),
          (null == e ? void 0 : e.overlay) &&
            (this.bannerProperties.overlay = e.overlay);
      }),
      (e.prototype.setBannerData = function (e, t) {
        var o = n({}, e);
        return (
          (null == t ? void 0 : t.acceptButtonCopy) &&
            (o.acceptButtonCopy = t.acceptButtonCopy),
          (null == t ? void 0 : t.declineButtonCopy) &&
            (o.declineButtonCopy = t.declineButtonCopy),
          (null == t ? void 0 : t.title) && (o.title = t.title),
          (null == t ? void 0 : t.bannerCopy) && (o.bannerCopy = t.bannerCopy),
          o
        );
      }),
      (e.prototype.render = function (e) {
        if (k())
          return Object.keys(e).length
            ? (this.addCSS(e), this.addBannerHTML(e), void this.show())
            : void console.warn(
                "banner not rendered due to lack of saved data"
              );
        this.merchantHasPublished(e) &&
          (this.addCSS(e),
          this.addBannerHTML(e),
          this.show(),
          this.logger.emitRender());
      }),
      (e.prototype.addCSS = function (e) {
        var t = be({ id: p.StyleId, content: E(e, !1, this.bannerProperties) });
        document.head.appendChild(t);
      }),
      (e.prototype.addCSSGranularConsentModal = function (e) {
        var t = be({ id: h.StyleId, content: x(e) });
        document.head.appendChild(t);
      }),
      (e.prototype.addBannerHTML = function (e) {
        var t = me({ id: p.DivId });
        t.appendChild(xe(e)),
          document.getElementsByTagName("body")[0].appendChild(t),
          this.addEventListeners(e);
      }),
      (e.prototype.addConsentModalHTML = function () {
        var e = me({ id: h.DivId });
        e.appendChild(we()),
          document.getElementsByTagName("body")[0].appendChild(e);
      }),
      (e.prototype.removeExistingElements = function () {
        var e,
          t,
          n = document.getElementById(p.DivId),
          o = document.getElementById(p.StyleId);
        null === (e = null == n ? void 0 : n.parentNode) ||
          void 0 === e ||
          e.removeChild(n),
          null === (t = null == o ? void 0 : o.parentNode) ||
            void 0 === t ||
            t.removeChild(o);
      }),
      (e.prototype.addEventListeners = function (e) {
        k() ||
          (this.addEssentialEventListeners(e), this.addMetricsEventListeners());
      }),
      (e.prototype.addEssentialEventListeners = function (e) {
        var t = this,
          n = document.getElementById(p.ButtonAcceptId);
        null == n ||
          n.addEventListener("click", function () {
            window.Shopify.customerPrivacy.setTrackingConsent(!0, t.hide);
          });
        var o = document.getElementById(p.ButtonDeclineId);
        null == o ||
          o.addEventListener("click", function () {
            window.Shopify.customerPrivacy.setTrackingConsent(!1, t.hide);
          });
        var r = document.getElementById(p.ButtonManageCookiesId);
        null == r ||
          r.addEventListener("click", function () {
            t.hide(),
              t.addCSSGranularConsentModal(e),
              t.addConsentModalHTML(),
              Be();
          });
      }),
      (e.prototype.addMetricsEventListeners = function () {
        var e = this,
          t = document.getElementById(p.PrivacyPolicyLinkId);
        null == t ||
          t.addEventListener("click", function () {
            e.logger.emitInteraction(u.PrivacyPolicyView);
          });
        var n = document.getElementById(p.ButtonAcceptId);
        null == n ||
          n.addEventListener("click", function () {
            e.logger.emitInteraction(u.Accepted);
          });
        var o = document.getElementById(p.ButtonDeclineId);
        null == o ||
          o.addEventListener("click", function () {
            e.logger.emitInteraction(u.Declined);
          });
      }),
      (e.prototype.merchantHasPublished = function (e) {
        return !0 === (null == e ? void 0 : e.visible);
      }),
      (e.adminPreviewBannerProperties = {
        bannerPlacement: f.BottomFullWidth,
        buttonPlacement: m.AcceptFirst,
        buttonWeight: g.Weighted,
        overlay: y.No,
      }),
      e
    );
  })();
  function Ee() {
    return o(this, void 0, void 0, function () {
      return r(this, function (e) {
        switch (e.label) {
          case 0:
            return k() || D() ? [4, new _e().init()] : [3, 2];
          case 1:
            e.sent(), (e.label = 2);
          case 2:
            return [2];
        }
      });
    });
  }
  window.Shopify &&
    window.Shopify.loadFeatures(
      [{ name: "consent-tracking-api", version: "0.1" }],
      function (e) {
        if (e) throw e;
        Ee();
      }
    ),
    (e.loadBanner = Ee),
    Object.defineProperty(e, "__esModule", { value: !0 });
})({});
